import { EventDirectiveModule } from '@b2c/common/directives/event/event.directive';
import { AnalyticsServiceModule } from '@b2c/common/services/analytics/analytics.service';
import { CalendarServiceModule } from '@b2c/common/services/calendar/calendar.service';
import { CartServiceModule } from '@b2c/common/services/cart/cart.service';
import { ComboServiceModule } from '@b2c/common/services/combo/combo.service';
import { EventsServiceModule } from '@b2c/common/services/events/events.service';
import { HelpersServiceModule } from '@b2c/common/services/helpers/helpers.service';
import { MembershipServiceModule } from '@b2c/common/services/membership/membership.service';
import { ThemesServiceModule } from '@b2c/common/services/themes/themes.service';
import { TODO, Timestamp } from '@b2c/types/index';
import angular from 'angular';

export const EventsListControllerModule = angular.module('acme.view.events.list.controllers', [
  CartServiceModule,
  EventsServiceModule,
  ComboServiceModule,
  CalendarServiceModule,
  HelpersServiceModule,
  ThemesServiceModule,
  MembershipServiceModule,
  AnalyticsServiceModule,
  EventDirectiveModule
])

.controller('EventsListController', ['$scope', '$state', '$filter', 'ReviewsSummaryData', 'EventsListData', 'EventsService', 'CartData', 'CartService', 'ThemesData', 'ThemesService', 'ComboService', 'ComboListData', 'MembershipService', 'CalendarService', 'HelpersService', 'AnalyticsService', function($scope, $state, $filter, ReviewsSummaryData, EventsListData, EventsService, CartData, CartService, ThemesData, ThemesService, ComboService, ComboListData, MembershipService, CalendarService, HelpersService, AnalyticsService) {

    $scope.eventsList = {

      model: {
        events: [],
        combos: []
      },
      reviewsSummary: {},
      stateParams: {},
      tenantId: '',
      averageRating: 0,
      tenantAllowsRatings: true,
      hasMembershipEvents: false,

      isVerifiedMembership: false,
      allowMembershipSales: false,

      venueHours: '',

      helpers: HelpersService,

      date: false,
      dateISO: '',
      dateParam: '',
      changeDateLabel: 'Select a date',
      getPrimaryImage: EventsService.getPrimaryImage,
      strip: HelpersService.strip,
      theme: ThemesService,

      weekdays: [
        {
          name: 'Sunday'
        },
        {
          name: 'Monday'
        },
        {
          name: 'Tuesday'
        },
        {
          name: 'Wednesday'
        },
        {
          name: 'Thursday'
        },
        {
          name: 'Friday'
        },
        {
          name: 'Saturday'
        }
      ],

      init: function() {

        this.tenantId = $state.params.tenantId;
        this.stateParams.tenantId = this.tenantId;

        if (ThemesData.data && ThemesData.data.success) {
          this.success.initThemes(ThemesData);
        }else{
          this.error.initThemes(ThemesData);
        }

        this.isVerifiedMembership = MembershipService.checkVerifiedMembership(this.tenantId);

        if ($state.params.date) {
          this.date = $filter('date')($state.params.date, 'EEEE, MMMM d, yyyy');
          this.dateISO = CalendarService.toISO8601($state.params.date);
          this.dateParam = '?date=' + this.dateISO;
          this.changeDateLabel = 'Change Date';
          this.stateParams.date = this.dateISO;
        }

        if (EventsListData.data && EventsListData.data.success) {
          this.success.init(EventsListData);
        }else{
          this.error.init(EventsListData);
        }

        if (CartData.data && CartData.data.success) {
          this.success.initCart(CartData);
        }else{
          this.error.initCart(CartData);
        }

        if (ReviewsSummaryData.data && ReviewsSummaryData.data.success) {
          this.success.initReviews(ReviewsSummaryData);
        }else{
          this.error.initReviews(ReviewsSummaryData);
        }

        if (ComboListData.data && ComboListData.data.success) {
          this.success.initCombos(ComboListData);
        }else{
          this.error.initCombos(ComboListData);
        }

        $scope.$on('Event::DetailClick', this.onEventDetailClick);
      },

      launchReviews: function() {

        var params: { tenantId: string; date?: Timestamp; } = {
          tenantId: this.tenantId
        };

        if ($state.params.date) {
          params.date = this.dateISO;
        }

        $state.go('events.reviews', params);
      },

      launchMembership: function(join) {
        var url,
            membership;

        if (join) {
          url = '/membership/' + $state.params.tenantId + '/join' + HelpersService.addDonationParams();
          AnalyticsService.event({
            name: 'Membership::Join',
            category: 'EventsList'
          });
        } else {
          membership = MembershipService.getVerifiedMember();

          url = '/membership/' + $state.params.tenantId + '/profile?membershipId=' + membership.membershipId + HelpersService.appendDonationParams();
          AnalyticsService.event({
            name: 'Membership::View',
            category: 'EventsList'
          });
        }

        HelpersService.setHref(url);
      },

      // Perform data conversions for display
      convert: function() {
        var i, ii;
        for (i=0,ii=$scope.eventsList.model.events.length;i<ii;i++) {
          $scope.eventsList.model.events[i].durationSummary = EventsService.getDuration($scope.eventsList.model.events[i].duration);
          //$scope.eventsList.model.events[i].eventTimes = EventsService.getTimes($scope.eventsList.model.events[i].schedules);
          $scope.eventsList.model.events[i].facilityName = EventsService.getFacilityName($scope.eventsList.model.events[i].resources);
        }
      },

      order: function(templateId, type, eventModel) {
        switch (type) {
          case 'combo':
            this.orderCombo(templateId);
            break;
          
          case 'member':
            this.orderMemberEvent(templateId, eventModel);
            break;
        
          default:
            this.orderEvent(templateId);
            break;
        }
      },

      orderCombo: function(templateId) {
        var qs = '',
            url = '/orders/' + this.tenantId,
            combo = ComboService.findCombo(this.model.combos, templateId);

        if (ComboService.comboContainsType(combo, 'any')) {
          // If there are choices involved we need to branch to a new view
          // Users will be allowed to choose which events they want to add to their combo
          url += '/combo?comboId=' + templateId;

          if (this.date) {
            url += '&date=' + encodeURIComponent($state.params.date);
          }

          HelpersService.setHref(url  + '&cart' + HelpersService.appendDonationParams());

        }else {
          qs = '&eventIds='+ComboService.getEventTemplateIds(combo).join(',');
          // If it is simply a set combo we should follow the original flow
          if (this.date) {
            HelpersService.setHref(url + '/tickets?comboId=' + templateId + qs + '&date=' + encodeURIComponent($state.params.date) + '&cart' + HelpersService.appendDonationParams());
          } else {
            HelpersService.setHref(url + '/calendar?comboId=' + templateId + qs + '&cart' + HelpersService.appendDonationParams());
          }
        }

      },

      orderMemberEvent: function(templateId, eventModel) {
        var membershipIds = MembershipService.getMembershipIds(false).join();
        var urlSegments: string[] = [];
        var queryParams: Partial<{
          eventId: string;
          membershipIds: string[];
          cart: boolean;
          date: Timestamp;
          ref: string;
        }> = {};

        var membershipCategoryIdsInCart = CartService.getMemberships('all').map(function(item) { return item.membershipInfo.membershipCategoryId; });
        var memberCanPurchaseFlags = (eventModel) ? MembershipService.validateMemberCanPurchaseEvent(eventModel, membershipCategoryIdsInCart) : {};

        // Check for membership before navigating
        if (this.isVerifiedMembership || memberCanPurchaseFlags?.hasEligibleMembershipInCart) {
          urlSegments.push('/orders');
          urlSegments.push(this.tenantId);

          queryParams.eventId = templateId;
          queryParams.membershipIds = membershipIds;
          queryParams.cart = true;

          if ($state.params.date) {
            urlSegments.push('tickets');
            queryParams.date = $state.params.date;
          } else {
            urlSegments.push('calendar');
          }
        } else {
          urlSegments.push('/auth');
          urlSegments.push(this.tenantId);
          urlSegments.push('members');

          var ref = $state.params.date ?
            HelpersService.makeUrl(['/orders', this.tenantId, 'tickets'], { eventId: templateId, cart: true, date: $state.params.date }) :
            HelpersService.makeUrl(['/orders', this.tenantId, 'calendar'], { eventId: templateId, cart: true });

          queryParams.ref = ref;
        }

        var url = HelpersService.makeUrl(urlSegments, queryParams)
        HelpersService.setHref(url);
      },

      orderEvent: function(templateId) {
        var membershipIds = MembershipService.getMembershipIds(true).join();

        var queryParams: Partial<{
          eventId: string;
          membershipIds: string[];
          cart: boolean;
          date: Timestamp;
        }> = {
          cart: true,
          membershipIds: membershipIds,
          eventId: templateId,
        };

        if ($state.params.date) {
          queryParams.date = $state.params.date;
        }

        var url = HelpersService.makeUrl(
          ['/orders', this.tenantId, queryParams.date ? 'tickets' : 'calendar'],
          queryParams
        );

        MembershipService.getCookie();

        HelpersService.setHref(url);

      },

      comboDetail: function(data) {
        var url =  '/events/' + this.tenantId,
          membershipIds = MembershipService.getMembershipIds(true).join();

        // Check for membership before navigating
        if (membershipIds) {
          if ($state.params.date) {
            url += '/detail/' + data.eventId + '?comboId=' + data.comboId + '&membershipIds=' + membershipIds + '&date=' + encodeURIComponent($state.params.date);
          } else {
            url += '/detail/' + data.eventId + '?comboId=' + data.comboId + '&membershipIds=' + membershipIds;
          }
        }else{
          if ($state.params.date) {
            url += '/detail/' + data.eventId + '?comboId=' + data.comboId + '&date=' + encodeURIComponent($state.params.date);
          } else {
            url += '/detail/' + data.eventId + '?comboId=' + data.comboId;
          }
        }

        HelpersService.setHref(url + HelpersService.appendDonationParams());

      },

      eventDetail: function(data) {

        var url =  '/events/' + this.tenantId,
          membershipIds = MembershipService.getMembershipIds(true).join();

        // Check for membership before navigating
        if (membershipIds) {
          if ($state.params.date) {
            url += '/detail/' + data.eventId + HelpersService.encodeDate($state.params.date) + '&membershipIds=' + membershipIds + HelpersService.appendDonationParams();
          } else {
            url += '/detail/' + data.eventId + '?membershipIds=' + membershipIds + HelpersService.appendDonationParams();
          }
        }else {
          if ($state.params.date) {
            url += '/detail/' + data.eventId + HelpersService.encodeDate($state.params.date) + HelpersService.appendDonationParams();
          } else {
            url += '/detail/' + data.eventId + HelpersService.addDonationParams();
          }
        }

        HelpersService.setHref(url);

      },

      cancelOrder: function() {
        if (CartService.clear()) {
          let q = this.dateParam;
          q += (q) ? HelpersService.appendDonationParams(): HelpersService.addDonationParams();
          HelpersService.setHref('/events/' + this.tenantId + '/list' + q);
        }
      },

      hasEvents: function() {
        return (this.model.events instanceof Array && this.model.events.length > 0);
      },

      hasMemberEvents: function() {
        return (this.model.memberEvents instanceof Array && this.model.memberEvents.length > 0);
      },

      hasCombos: function() {
        return (this.model.combos instanceof Array && this.model.combos.length > 0);
      },

      getAverageRating: function() {
        return $scope.eventsList.averageRating = $scope.eventsList.reviewsSummary.stars / $scope.eventsList.reviewsSummary.ratings;
      },

      hasReviews: function() {
        return ($scope.eventsList.reviewsSummary.ratings > 0);
      },

      updateVenueHours: function() {
        var self = $scope.eventsList;
        self.venueHours = self.date ? self.getFormattedVenueHours(new Date(self.date)) : '';
      },

      getVenueHours: function () {
        var self = $scope.eventsList, r = "";
        if (self.date) {
          r = self.getFormattedVenueHours(new Date(self.date));
        }
        return r;
      },

      getFormattedVenueHours: function(eventDate) {
        var self = $scope.eventsList,
          openHours = self.theme.model.events.openHours || {},
          exceptionDates = openHours.exceptions || [],
          standardDates = openHours.standard || [],
          hours, r = '', prefix = 'Hours: ';
        if(eventDate) {
          eventDate = CalendarService.getParsableDate(eventDate);
          eventDate.setHours(0,0,0,0);
          hours = self.hasDateException(exceptionDates, eventDate) || self.hasDateStandard(standardDates, eventDate);
          if (hours) {
            for (var i = 0; i < hours.length; i++) {
              r = r + this.getFormattedSlotTime(hours[i]);
              if( i + 1 < hours.length) {
                r = r + ", ";
              }
            }
            if(r.toLowerCase().indexOf('closed') < 0) {
              prefix = 'Hours: Open ';
            }
            r = r ? (prefix + r) : r;
          }
        }
        return r;
      },

      hasDateException: function(exceptionList, eDate) {
        var exceptionDate, i, ii, hours = false,
          eventDate = eDate || false, dateParts;
        if (eventDate) {
          for (i = 0, ii=exceptionList.length; i < ii; i++) {
            dateParts = exceptionList[i].date ? exceptionList[i].date.split('-') : [];
            if(dateParts.length === 3) {
              exceptionDate = new Date(dateParts[0], +dateParts[1]-1, dateParts[2]);
              exceptionDate.setHours(0,0,0,0);
              if ( exceptionDate.getTime() === eventDate.getTime() ) {
                hours = exceptionList[i].hours;
                break;
              }
            }
          }
        }
        return hours;
      },

      hasDateStandard: function(standardList: TODO[], eventDate) {
        let hours: string[] | false = false;
        let eventWeekday: string;
        let weekdayFound = false;

        if (eventDate) {
          eventWeekday = $scope.eventsList.weekdays[eventDate.getDay()].name;
          for (let i = 0, ii = standardList.length; i < ii; i++) {
            if(standardList[i].weekdays && (standardList[i].weekdays[0] === eventWeekday) ) {
              hours = standardList[i].hours;
              weekdayFound = true;
              break;
            }
          }
          if(!weekdayFound) {
            hours = ["Closed"];
          }
        }
        return hours;
      },

      getFormattedSlotTime: function(time) {
        var r = '',
          t, hrs, m, p, tz,
          st, hrs1, hrs2,
          h1, m1, p1, tz1,
          h2, m2, p2, tz2;

        if (time) {
          console.log('Hours: '+time);
          if (time.indexOf('-') > -1) {
            st = time.split('-');
            hrs1 = st[0].split(':');
            hrs2 = st[1].split(':');

            h1 = hrs1[0].replace(/0(\d+)/, "$1");
            m1 = hrs1[1].replace(/(A|P)*M/gi, '');
            p1 = ( +h1 >= 12) ? ' PM - ' : ' AM - ';

            h2 = hrs2[0].replace(/0(\d+)/, "$1");
            m2 = hrs2[1].replace(/(A|P)*M/gi, '');
            p2 = ( +h2 >= 12) ? ' PM' : ' AM';

            if ( +h1 > 12) {
              r += (h1 - 12);
            }else {
              r += h1;
            }
            if (+m1 > 0) {
              r += ':' + m1;
            }

            r += p1;

            if( +h2 > 12) {
              r += (h2 - 12);
            }else {
              r += h2;
            }
            if (+m2 > 0) {
              r += ':' + m2;
            }

            r += p2;

          }else {
            if (time.toLowerCase() === 'closed') {
              r += 'Closed';
            }
          }
        }

        return r;

      },

      processEvents: function(events: TODO[]) {
        const r: TODO[] = [];

        for (let i = 0, ii = events.length; i < ii; i++) {
          if (this.theme.getCompany('sortTemplatesByDisplayOrder')) {
            if (events[i].hasOwnProperty('membership') &&
              events[i].membership.restrictions instanceof Array) {
              this.hasMembershipEvents = true;
              if (events[i].membership.restrictions.length > 0) {
                events[i].eventOrderType = 'member';
              }
            }
            r.push(events[i]);
          }else{
            if (!events[i].hasOwnProperty('membership')) {
              r.push(events[i]);
            } else if (events[i].hasOwnProperty('membership') &&
              events[i].membership.restrictions instanceof Array &&
              events[i].membership.restrictions.length === 0) {
              this.hasMembershipEvents = true;
              r.push(events[i]);
            }
          }
        }

        return r;
      },

      processMemberEvents: function(events: TODO[]) {
        const r: TODO[] = [];

        for (let i = 0, ii = events.length; i < ii; i++) {
          if (events[i].hasOwnProperty('membership') &&
              events[i].membership.restrictions instanceof Array &&
              events[i].membership.restrictions.length > 0) {
            this.hasMembershipEvents = true;
            r.push(events[i]);
          }
        }

        return r;
      },

      success: {
        init: function(response) {
          var self = $scope.eventsList,
              responseData = JSON.parse(response.data.payload);

          self.model.events = self.processEvents(responseData);
          self.model.memberEvents = self.processMemberEvents(responseData);
          self.convert();
        },

        initCart: function(response) {
          CartService.data = response.data.payload;
          $scope.$emit('App::UpdateCartItems', {
            count: CartService.getItemCount()
          });
        },

        initThemes: function(response) {
          $scope.eventsList.theme.model.events = response.data.payload;
          $scope.eventsList.allowMembershipSales = $scope.eventsList.theme.model.events.company.membershipSales;
          $scope.eventsList.tenantAllowsRatings = $scope.eventsList.theme.model.events.company.reviews;
          $scope.eventsList.updateVenueHours();
        },

        initCombos: function(response) {
          $scope.eventsList.model.combos = response.data.payload.list;
        },

        initReviews: function(response) {
          $scope.eventsList.reviewsSummary = response.data.payload;
        }
      },

      error: {
        init: function (response) {},
        initCart: function (response) {},
        initCombos: function(response) {},
        initThemes: function(response) {},
        initReviews: function(response) {}
      },

      onEventDetailClick: function(e, data) {
        if (data.type === 'combo') {
          $scope.eventsList.comboDetail(data);
        }else{
          $scope.eventsList.eventDetail(data);
        }
      },

      onVerifyMembership: function(props: { eventTemplateId: string; }) {
        var self = $scope.eventsList;

        var dateParam = self.date ? $state.params.date : undefined;
        var ref = HelpersService.makeUrl(['/events', self.tenantId, 'list'], { date: dateParam });
        var url = HelpersService.makeUrl(['/auth', self.tenantId, 'members'], { date: dateParam, ref: ref });

        HelpersService.setHref(url);
      },

      addURLParams: function() {
        var self = $scope.eventsList;
        return (self.dateParam) ? self.dateParam + HelpersService.appendDonationParams(): HelpersService.addDonationParams();
      }

    };

    $scope.eventsList.init();

}]).name;